export const phrases = {
  heading_settings_sort: "Třídění seznamu zaměstnanců",
  body_settings_sort: "Seřaďte seznam zaměstnanců podle jména nebo příjmení.",
  since_o_clock: "Od {time} hodiny",
  old_data_warning_my_area: "Nepodařilo se nám načíst žádné nové informace. Zkontrolujte, zda jste připojeni k internetu.",
  no_data_warning_my_area: "Zkontrolujte, zda jste připojeni k internetu, a zkuste to znovu.",
  no_data_available_my_area: "Nelze načíst žádná data",
  last_update_data: "Poslední aktualizace",
  something_went_wrong_absences: "Něco se pokazilo. Zkuste to prosím později.",
  something_went_wrong_with_the_pin_entry: "Něco se pokazilo při zadávání kódu PIN...",
  pin_must_be_four_digits: "PIN musí obsahovat přesně čtyři číslice.",
  pins_do_not_match: "Zadané kódy PIN se neshodují.",
  pin_is_not_numerical: "PIN se může skládat pouze z čísel.",
  /** Phrasen für Task.getTechnicalNameFinish
   * -> müssen vermutlich irgendwann nochmal bearbeitet werden
   * z.B. 'Projekt beenden' macht eventuell keinen Sinn, wenn man das Projekt nicht beendet,
   * sondern nur die Arbeitszeit, die man auf dieses Projekt stempelt ?
   */
  finish_work_time: "Razítko",
  finish_break: "Konec přestávky",
  finish_loading_time: "Doba načítání na konci",
  finish_driving_time: "Koncová doba jízdy",
  finish_business_trip: "Ukončení služební cesty",
  finish_project_as_task: "Dokončení projektu",
  finish_special_one: "Konec speciální1",
  finish_special_two: "Konec speciálu2",
  you_clockout: "Vyrazíte si razítko",
  sentence_work_time: "Pracujete. | Právě teď pracujete.",
  sentence_break: "Dáváte si pauzu. | Dáváte si pauzu.",
  sentence_loading_time: "Právě zaznamenáváte dobu načítání. Hauruck! | Právě zaznamenáváte dobu načítání. Blbost!",
  sentence_business_trip: "Služba přihlášena. Bavte se!",
  sentence_driving_time: "Rezervujete si čas jízdy. Připoutejte se a jeďte! | Rezervujete si čas na cestu. Připoutejte se a jeďte!",
  sentence_special_one: "Provádíte rezervaci Speciální 1. | Rezervujete speciální 1.",
  sentence_special_two: "Objednáváte si Speciální 2. | Rezervujete speciální 2.",
  sentence_custom_time: "Provádíte rezervaci | Provádíte rezervaci",
  you_are_booked_in_activity: "Razítko {activity}! | Razítko {activity}!",
  substitute_warning: "{ days } V případě několikadenní nebo delší nepřítomnosti musí být jmenován zástupce.",
  substituted_by: "Zastoupený",
  name_clocked_in: "{name} s razítkem",
  /************************************/
  //Signature stuff:

  signature: "Podpis",
  please_sign: "Prosím podepište se",
  signature_with_date: "Podpis z {date}",
  signature_with_date_with_name: "Podpis {date} z {name}",
  signature_with_date_with_location: "Signature from {date} in {location}",
  signature_with_date_with_name_with_location: "Signature of {date} from {name} in {location}",
  signature_with_name: "Podpis na {name}",
  signature_with_name_with_location: "Podpis na {name} v {location}",
  signature_with_location: "Podpis na {location}",
  /*************************************/

  accept_terms_and_conditions: "Odesláním formuláře souhlasíte s našimi stránkami {agb} a {datenschutzerklaerung}.",
  what_is_your_name: "Jak se jmenujete?",
  your_email: "Vaše e-mailová adresa",
  what_is_your_company_name: "Jak se jmenuje vaše společnost?",
  what_do_you_want_to_do_with_clockin: "Jak chcete zaznamenávat pracovní dobu v aplikaci clockin?",
  almost_finished: "Téměř tam",
  test_clockin_for_amount_period: "Vyzkoušejte clockin {amountOfDaysTestPeriod} na několik dní zdarma!",
  code_needed_to_connect: "Použijte svůj kód",
  you_have_no_company_code: "Nemáte kód? Obraťte se na osobu ve vaší společnosti.",
  connect_your_device: "Připojte své zařízení!",
  please_type_in_device_id: "Zadejte prosím ID zařízení, které najdete na našich webových stránkách v části mobilní zařízení.",
  new_at_clockin: "Jste v clockinu nováčkem?",
  pin_repeat: "Opakování kódu PIN",
  configure_your_pin: "Nastavení čtyřmístného kódu PIN",
  configure_your_pin_text: "Pro přístup do osobní zóny na terminálu tabletu potřebujete PIN.",
  congratulations: "Gratulujeme!",
  start_now: "Začněte hned teď",
  device_name_info: "Název zařízení mobilního zařízení můžete změnit, abyste mohli sledovat několik zařízení. Příklad: \"Smartphone MaxMustermann\". Název lze změnit i později.",
  select_project: "Vybrat projekt",
  select_time: "Vybraný čas",
  create_new_account: "Vytvořit nový účet",
  join_my_company: "Přidejte se k mé firmě",
  join_clockin_with_qr: "Připojte se pomocí kódu QR",
  change_project: "Projekt změny",
  my_messages: "Moje zprávy",
  my_documents: "Moje dokumenty",
  my_data_and_passwords: "Moje data a hesla",
  my_account_data: "Moje data",
  change_my_password: "Změna hesla",
  forgot_password: "Neznám své heslo.",
  open_camera: "Otevřená kamera",
  scan_now: "Skenovat nyní",
  sync_now: "Synchronizovat nyní",
  clear_logs: "Prázdné protokoly",
  saveAndGoBack: "Uložit a vrátit",
  full_day: "Celý den",
  activate_scanner: "Skener je aktivován",
  scanner_is_inactive: "Skener je neaktivní",
  change_project_by_scan_qr: "Naskenujte QR kód projektu, na který chcete přepnout.",
  scan_device_by_qr: "Naskenujte QR kód ze zařízení, které chcete použít.",
  no_access_to_camera_please_connect_device_manually: "K fotoaparátu se bohužel nepodařilo získat přístup, zadejte prosím kód zařízení ručně.",
  no_access_to_camera_please_clockin_manually: "Bohužel nebyl možný přístup k fotoaparátu, otiskněte prosím ruční razítko.",
  qr_code_login: "Registrace kódu QR",
  scan_to_login: "Pro přihlášení naskenujte kód QR.",
  checklist_was_saved: "Kontrolní seznam byl uložen",
  question_save_changes_short: "Uložit změny?",
  question_save_changes: "Chcete změny uložit?",
  question_delete_checklist_short: "Vymazat kontrolní seznam?",
  question_delete_checklist: "Určitě chcete kontrolní seznam odstranit?",
  checklist_is_sending: "Checklist bude zaslán",
  checklist_sent_successfully: "Kontrolní seznam byl úspěšně 🎉 odeslán",
  checklist_could_not_be_sent: "Kontrolní seznam nelze odeslat, zkuste to prosím znovu později.",
  checklist_transmission_problems_in_the_past: "V minulosti se u některých souborů vyskytly problémy s přenosem.",
  checklist_send_with_potential_data_loss: "Chcete se pokusit odeslat kontrolní seznam bez těchto souborů?",
  documentation_is_sending: "Projektová dokumentace je zasílána",
  documentation_sent_successfully: "Projektová dokumentace úspěšně odeslána 🎉",
  confirm_documentation_dismissal: "Opravdu chcete zlikvidovat dokumentaci?",
  discard_unsaved_changes: "Chcete své změny zahodit?",
  documentation_will_be_sent_when_online: "Dokumentace vám bude zaslána, jakmile budete opět online.",
  confirmation_is_sending: "Potvrzení projektu je odesláno",
  ask_for_geo_permission: "Tato aplikace potřebuje vaši polohu, " + "ale nemá k tomu oprávnění.\n\n" + "Chcete otevřít nastavení?",
  all_projects: "Všechny projekty",
  half_day: "Půl dne",
  start_end: "Podle času",
  my_area: "Moje oblast",
  my_area_video_teaser_clockin_explained_by_frederik: "hodiny vysvětlil Freddi",
  add_time: "Vytvořit čas",
  show_times_in_confirmation: "Ukázat časy v potvrzení",
  change_time: "Čas změny",
  finish_project: "Kompletní projekt",
  finish_project_date: "Dokončení jmenování",
  unfinish_project: "Znovuotevření projektu",
  unfinish_project_date: "Znovuotevření schůzky",
  absence_overview: "Správa absencí",
  edit_absence: "Upravit nepřítomnost",
  edited_absence: "Upravená nepřítomnost",
  created_absence: "Žádost o dovolenou byla úspěšně vytvořena",
  creating_absence: "Vaše žádost o dovolenou je nyní vytvořena",
  error_creating_absence: "Chyba při vytváření požadavku na nepřítomnost",
  create_absence: "Vytvořit nepřítomnost",
  deleted_absence: "Stažení žádosti o nepřítomnost",
  new_request: "Nová aplikace",
  your_requests: "Vaše aplikace",
  planned_days: "Plánované dny",
  planned_hours: "Naplánované hodiny",
  used_days: "Využité dny",
  used_hours: "Odpracované hodiny",
  free_days: "Dny volna",
  free_hours: "Prázdninové hodiny",
  open_days: "Dny otevřených dveří",
  open_hours: "Otevírací doba",
  withdraw_request: "Stažení žádosti",
  change_request: "Žádost o změnu",
  request_was_approved: "Vaše žádost byla schválena",
  request_is_pending: "Vaše žádost ještě nebyla schválena",
  request_was_rejected: "Vaše žádost byla zamítnuta",
  add_attachment: "Přidat přílohu",
  message_optional: "Zpráva (nepovinné)",
  filed_on: "Odesláno dne",
  this_year: "V letošním roce",
  search_sub_projects: "Na kterém dílčím projektu byste chtěli pracovat?",
  error_occurred: "Došlo k chybě, zkuste to znovu později.",
  re_record: "Smazat a znovu nahrát toto video?",
  delete_video: "Smazat nahrávku?",
  no_results_found: "Nebyly nalezeny žádné výsledky",
  record_again: "Zkusit ještě jednou",
  request_valid_email: "Zadejte prosím platnou e-mailovou adresu.",
  request_valid_company_name: "Zadejte prosím platný název společnosti.",
  request_valid_first_name: "Zadejte prosím platné křestní jméno.",
  request_valid_last_name: "Zadejte prosím platné příjmení.",
  total_duration_today: "Celkový čas dnes",
  show_daily_protocol: "Zobrazit denní záznam",
  change_profile_pic: "Změna profilového obrázku",
  logout_account: "Odpojení účtu",
  you_are_working: "Právě teď pracujete!",
  you_are_taking_a_break: "Máte přestávku!",
  activity_edited: "Upravená činnost",
  activity_edited_undo: "Úspěšné zrušení zpracování",
  activity_edited_missing_project: "Projekt stále chybí!",
  activity_deleted: "Smazaná aktivita",
  activity_deleted_undo: "Obnovení odstraněné aktivity",
  activity_created: "Vytvoření nové aktivity",
  activity_created_undo: "Nově vytvořená aktivita stažena",
  correct_working_hours: "Správná pracovní doba",
  your_changes_are_being_saved: "Vaše změny jsou nyní uloženy.",
  manage_working_hours: "Řízení pracovní doby",
  delete_activity: "Odstranění činnosti",
  start_navigation: "Spuštění navigace",
  no_valid_email: "Zadaná e-mailová adresa není platná.",
  delete_checklist: "Odstranit kontrolní seznam",
  active_checklists: "Aktivní kontrolní seznamy",
  scan_qr_code: "Naskenování kódu QR",
  switch_to_office_center: "Přepnutí na kancelářské centrum",
  confirm_project_completion_short: "Kompletní projekt",
  confirm_project_date_completion_short: "Dokončení jmenování",
  project_completed: "Projekt dokončen!",
  project_date_completed: "Jmenování dokončeno!",
  confirm_project_uncompletion_short: "Znovuotevření projektu",
  confirm_project_date_uncompletion_short: "Znovuotevření schůzky",
  project_uncompleted: "Projekt aktivován",
  project_date_uncompleted: "Datum aktivace",
  choose_project: "Vybrat projekt",
  choose_sub_project: "Vyberte dílčí projekt",
  choose_site: "Zvolte umístění",
  active_projects: "Aktivní projekty",
  completed_term: "dokončeno",
  completed_projects: "Dokončené projekty",
  end_of_work: "Přeji hezký večer",
  correct_time: "Správný čas",
  you_stamp_x: "Razítko",
  enter_pin: "Zadejte prosím PIN",
  wrong_pin: "Nesprávné zadání kódu PIN",
  pin_change_required: "Byli jste vyzváni ke změně kódu PIN",
  enter_new_pin: "Zadejte nový kód PIN",
  approve_pin: "Potvrzení kódu PIN",
  no_projects_scheduled: "Pro {day} Neukládají se žádné projekty.",
  you_clock_in_project: "Od této chvíle zaznamenáváte pracovní dobu projektu.",
  project_scan_error: "Tento kód není platný pro žádný projekt.",
  show_more_days: "zobrazit další dny",
  show_more_times: "Zobrazit více časů",
  only_show_today: "Zobrazit pouze dnes",
  todays_total_time: "Celkový čas dnes",
  everything_synced: "Vaše data jsou aktuální!",
  upload_in_progress: "Data se nahrávají...",
  who_are_you: "Kdo jsi?",
  is_uploading_to_server: "Vaše změny se přenášejí do kancelářského centra.",
  offline_and_data_is_stored_locally: "Vaše změny budou brzy přeneseny do kancelářského centra. ",
  show_more: "zobrazit více",
  activity_edited_wrong_date: "Zadali jste špatné datum.",
  confirm_logout: "Opravdu se chcete odhlásit?",
  confirm_clockout: "Jste si jistý, že chcete pro dnešek odejít?",
  gps_is_active: "Přenos dat GPS",
  location_tracking_is_active: "Povolení sledování GPS.",
  app_settings: "Nastavení aplikace",
  clock_reminder: "Známka – připomínka",
  mon_to_fri: "Standard: pondělí - pátek",
  logout: "Odpojení účtu",
  refresh: "Aktualizace",
  prompt_language_settings: "Zde nastavte jazyk aplikace.",
  prompt_clock_reminder: "Připomínka prostřednictvím push notifikací, aby odpovídala vaší každodenní práci.",
  register_company: "Registrace společnosti",
  use_code: "Použijte kód",
  our_customers: "Naši zákazníci",
  free_test_now: "Testování je nyní zdarma",
  tier_attendance: "Zaznamenávám pouze pracovní dobu a přestávky.",
  tier_documentation: "Chci také zaúčtovat pracovní hodiny na projektech, které spravuji v režimu clockin.",
  your_tier: "Váš balíček",
  all_clockin_functions: "Všechny funkce clockin",
  checklists_formulars: "Kontrolní seznamy a funkce",
  projectfile_incl_chat: "Digitální soubory projektu (včetně chatu)",
  photo_sketch_note: "Funkce fotografie, náčrtu a poznámky",
  digital_signature: "Digitální podpisy",
  datev_connection: "Připojení DATEV",
  calendar_absences: "Správa kalendáře a absencí",
  individual_design: "Individuální vzhled",
  attendance_time_tracking: "Stacionární záznam času prostřednictvím terminálu tabletu",
  mobile_time_tracking: "Mobilní záznam času prostřednictvím aplikace pro chytré telefony",
  browser_time_tracking: "Záznam času prohlížeče na počítači pro domácí kancelář",
  help_use_code: "Zadejte kód, který najdete v centru kanceláře v části mobilní zařízení/zaměstnanci.",
  wrong_code: "Špatný kód",
  wrong_code_text: "Kód není platný. Zkuste to prosím znovu s platným kódem",
  wrong_code_text_short: "Kód je neplatný",
  clockin_logo: 'Clockin Logo',
  invalid_qr_code: "Neplatný QR kód",
  invalid_qr_code_text: "Naskenovaný QR kód není platný. Naskenujte prosím platný kód Clockin.",
  code_already_connected: "Pomocí tohoto kódu můžete připojit zařízení. Ale vy jste již připojeni.",
  wrong_credentials: "Nesprávné přístupové údaje",
  wrong_credentials_text: "Zadanou kombinaci e-mailu a hesla se nepodařilo najít. Zkontrolujte prosím zadání a zkuste to znovu.",
  new_pin: "Zadejte nový kód PIN",
  choose_next_action: "Vyberte si další akci",
  name_of_software_package: "Název softwarového balíčku",
  select_teamleader: "Kdo razítkuje za tým?",
  select_teamleader_description: "Chcete-li pokračovat v razítkování, vyberte osobu, která nyní stroj převezme.",
  clocked_in_on_this_device: "Vyraženo na této jednotce",
  not_clocked_in_on_this_device: "Na této jednotce není vyraženo",
  select_new_teamleader: "Kdo by měl nyní razítkovat za tým?",
  switch_teamleader: "Předání jednotky",
  just_me: "Právě odbíjím hodiny",
  select_the_new_teamleader: "Určení nového vedoucího týmu",
  back_to_selection: "zpět na výběr",
  manage_team: "Řízení týmu",
  total_time_team: "Celkový čas týmu",
  count_members_clocked_in: "{clockedin}/{members} Členové týmu s razítkem",
  whole_team: "Celý tým",
  teammembers_still_clockedin: "Můžete si vybrat, zda chcete odpracovat hodiny jen pro sebe, nebo pro všechny členy týmu?",
  clockout_all: "Vymýtit všechny",
  select_employee: "Nejprve vyberte uživatele",
  something_went_wrong: "Něco se pokazilo, zkuste to prosím později.",
  new_pin_successfully_changed: "Úspěšná změna kódu PIN",
  enter_pin_before_clockin_prompt: "Nejprve zadejte postupně svůj kód PIN a přihlaste se.",
  enter_pin_before_clockout_prompt: "Nejprve postupně zadejte svůj kód PIN, abyste se mohli odhlásit.",
  delete_activity_alert_title: "Odstranění činnosti",
  delete_activity_alert_msg: "Jste si jisti, že chcete aktivitu odstranit?",
  delete_absence_message: "Jste si jisti, že chcete žádost stáhnout?",
  delete_absence_title: "Stažení žádosti",
  are_you_sure: "Jste si jistý?",
  request_password: "Žádost o nové heslo",
  password_requested: "Na vaši e-mailovou adresu byl zaslán odkaz pro nové heslo.",
  no_email_retrieved: "Nedostali jste e-mail? Zkontrolujte prosím složku se spamem nebo to zkuste znovu.",
  name_of_customer: "Jméno zákazníka",
  missing_permissions_homepage_text: "Nemáte oprávnění měnit svou aktivitu na tomto počítači. Pro získání přístupu se obraťte na svého správce.",
  no_permission_warning_my_area: "K přístupu do této oblasti nemáte oprávnění. Pro získání přístupu se obraťte na svého správce.",
  employee_clocked_in: "{name} registrován!",
  employee_clocked_out: "{name} odhlášen!",
  no_employee_to_qr_code_warning: "Pro tento QR kód se nepodařilo najít žádného zaměstnance.",
  no_employees_registered_heading: "Do této jednotky zatím nebyl přidělen žádný zaměstnanec.",
  no_employees_registered_body: "V kancelářském centru v nastavení mobilního zařízení můžete přiřadit zaměstnance, kteří pak mohou na tomto zařízení zaznamenávat svůj čas.",
  no_employee_found: "Bohužel se nepodařilo najít nikoho s tímto jménem.",
  no_employee_assigned: "Žádný zaměstnanec není přidělen",
  you_need_help: "Potřebujete pomoc?",
  here_you_can_get_help_to_register_employees_for_device: "Zde najdete veškeré informace o přiřazení zaměstnanců k jednotce.",
  show_time: "Vytvořit čas",
  export_timesheet: "Exportovat časový výkaz",
  select_month: "Zvolte měsíc",
  internet_connection_required: "K tomu je nutné připojení k internetu.",
  select_an_activity_to_clockin_your_team: "Vyberte aktivitu, kterou chcete ve svém týmu orazítkovat.",
  confirm_uploading_sqlite_for_debugging: "Jste si jisti, že chcete data nahrát do aplikace pro podporu Clockin?",
  no_tasks_available: "Žádné úkoly nejsou k dispozici",
  click_to_add_tasks: "Klikněte pro přidání úkolů",
  scan_nfc_tag: "Přiložte prosím svou kartu ke čtečce.",
  link_nfc_tag: "Propojit značku NFC",
  select_employee_for_nfc_tag: "Vyberte prosím zaměstnance, se kterým chcete tento NFC tag propojit:",
  nfc_tag_linked_successfully: "NFC tag úspěšně s {name} spojen.",
  nfc_linking_failed: "Značku NFC nelze propojit. Zkuste to prosím znovu.",
  nfc_not_enabled: "Toto zařízení nepodporuje technologii NFC nebo je zakázáno.",
  nfc_initialization_failed: "Bohužel se něco pokazilo. Zkuste to prosím znovu.",
  nfc_scan_failed: "Bohužel se něco pokazilo. Zkuste to prosím znovu.",
  nfc_no_tag_found: "Nebyl nalezen žádný NFC tag.",
  nfc_tag_already_linked_to: "Tento NFC tag je již k dispozici s {name} spojen.",
  nfc_scan_active: "NFC skenování je aktivní",
  nfc_linking_enabled: "NFC tagy lze nyní propojit. Nyní si podržte značku NFC, kterou chcete propojit se čtečkou NFC.",
  nfc_all_employees_linked: "Všichni zaměstnanci přiřazení k tomuto zařízení již byli propojeni.",
  no_employee_to_nfc_warning: "Pro tento NFC tag se nepodařilo najít žádného zaměstnance.",
  select_employee_to_link_nfc: "Na koho by měla být značka NFC odkazována?",
  new_onboarding: {
    personal_app_manager: {
      heading: {
        welcome: "Vítejte u Clockin",
        clocking_time: "Časy na trati",
        push_notifications: "Na nic nezapomeň"
      },
      text: {
        clocking_time: "Hodinovač je výchozím bodem pro každou činnost. Vy se staráte o svou práci, aplikace dělá dokumentaci.",
        push_notifications: "Teď zapněte oznámení. Clockin vám připomene, pokud zapomenete známku, a zajistí, že vše důležité dostanete hned."
      },
      button: {
        lets_go: "Začněte hned teď"
      }
    },
    my_area: {
      heading: {
        my_area: "Moje oblast",
        absences: "Absence a žádosti",
        settings: "Osobní nastavení"
      },
      text: {
        my_area: "Centrální místo, kde máte okamžitý přehled o své pracovní době a přesčasech. Odtud můžete spravovat svou pracovní dobu, přistupovat k dennímu záznamu, zadávat požadavky a prohlížet si své časy.",
        absences: "Správa žádostí o dovolenou, dnů pracovní neschopnosti a dalších nepřítomností. Mějte vždy přehled o stavu svých žádostí a nové žádosti zadávejte snadno a rychle pomocí několika kliknutí.",
        settings: "Odesílejte zprávy společnosti nebo změňte svá osobní nastavení, a pokud chcete změnit heslo, můžete to udělat také zde!"
      },
      button: {
        lets_go: "Začněte"
      }
    }
  },
  onboarding: {
    personal_app: {
      heading: {
        your_time_matters: "Protože váš čas se počítá",
        clock_in: "Razítko v",
        switch_task: "Změna razítka",
        clock_out: "Razítko",
        thats_it: "A je to!"
      },
      text: {
        your_time_matters: "S funkcí clockin vám pomůžeme soustředit se na to podstatné. Zaznamenávejte svou pracovní dobu jediným kliknutím.",
        clock_in: "Jedním kliknutím se přímo přihlásíte. Clockin automaticky ukládá vaše data a vy máte vše neustále na očích.",
        switch_task: "Máte další projekt, přestávku nebo míříte na další schůzku? Jednoduše si na novou aktivitu dejte nové razítko. Zbytek se zaznamená automaticky.",
        clock_out: "Jedním kliknutím je vše vytištěno.",
        thats_it: "Máte to za sebou a jste připraveni zaznamenávat svou pracovní dobu. Pokud potřebujete pomoc, obraťte se na nás. S clockinem je vše snadné - včetně komunikace s námi."
      },
      button: {
        your_time_matters: "Ukaž mi, jak se to dělá",
        thats_it: "Začněte hned teď"
      }
    },
    team_app: {
      heading: {
        your_time_matters: "Protože váš čas se počítá",
        clock_in: "Razítko v",
        clock_in_team: "Odbavovací tým",
        switch_task: "Změna razítka",
        change_teamleader: "Předání jednotky",
        clock_out: "Razítko",
        thats_it: "A je to!"
      },
      text: {
        your_time_matters: "S funkcí clockin vám pomůžeme soustředit se na to podstatné. Zaznamenávejte pracovní dobu svého týmu jediným kliknutím.",
        clock_in: "Zvolte osobu, která odbavuje tým, a jediným kliknutím ji přímo odbavíte. clockin automaticky ukládá data a vy máte o všem neustále přehled.",
        clock_in_team: "Stačí, když svůj tým přímo orazítkujete. Ať už všichni najednou, nebo jen jednotliví členové.",
        switch_task: "Máte další projekt, přestávku nebo cestujete na další schůzku? Jednoduše si novou aktivitu orazítkujte. Zbytek se zaznamená automaticky.",
        change_teamleader: "Končíte v práci, musíte odejít nebo už nepracujete pro tým? Jednoduše předejte zařízení v aplikaci a vše se vrátí do normálu.",
        clock_out: "Jediným kliknutím vy i váš tým odejdete. Samozřejmě můžete kdykoli odhlásit i jednotlivé členy.",
        thats_it: "Máte to za sebou a jste připraveni evidovat pracovní dobu svého týmu. Pokud potřebujete pomoc, obraťte se na nás. S clockinem je vše snadné - včetně komunikace s námi."
      },
      button: {
        your_time_matters: "Ukaž mi, jak se to dělá",
        thats_it: "Začněte hned teď"
      }
    },
    my_area: {
      heading: {
        welcome: "Vítejte ve své oblasti",
        my_area: "Moje oblast",
        create_time: "Vytvořit čas",
        change_time: "Správný čas",
        absences: "Absence a žádosti",
        settings: "Osobní nastavení",
        thats_it: "A je to!"
      },
      text: {
        welcome: "Objevte ještě více způsobů, jak efektivně a snadno řídit svůj pracovní čas. Podívejme se na vaši oblast.",
        my_area: "Centrální místo, kde máte okamžitý přehled o své pracovní době a přesčasech. Odtud můžete spravovat svou pracovní dobu, přistupovat k dennímu záznamu, zadávat požadavky a prohlížet si své časy.",
        create_time: "Zapomněli jste zadat čas nebo chcete časy přidat později? Žádný problém! Přidávejte chybějící časy, zaznamenávejte přestávky a udržujte svůj účet pracovní doby aktuální.",
        change_time: "Chcete si opravit časy? Žádný problém! Pomocí funkce clockin můžete snadno opravit a upravit nesprávné časy.",
        absences: "Správa žádostí o dovolenou, dnů pracovní neschopnosti a dalších nepřítomností. Mějte vždy přehled o stavu svých žádostí a nové žádosti zadávejte snadno a rychle pomocí několika kliknutí.",
        settings: "Odesílejte zprávy společnosti nebo změňte svá osobní nastavení, a pokud chcete změnit heslo, můžete to udělat také zde!",
        thats_it: "Dokázali jste to! Nyní můžete bez námahy řídit svůj čas, organizovat nepřítomnost a soustředit se na to, co je důležité: na svou práci. Hodně štěstí s produktivním časem!"
      },
      button: {
        welcome: "Ukaž mi, jak se to dělá",
        thats_it: "Začněte hned teď"
      }
    },
    clock: {
      clockin_now: "Uzamknout nyní",
      clock_your_first_time_now: "& nahrávejte poprvé"
    }
  },
  surveys: {
    nps: {
      thanks_for_using_clockin: "Děkujeme, že používáte clockin!",
      question: "Jaká je pravděpodobnost, že doporučíte službu clockin svým přátelům nebo kolegům?",
      very_likely: "Velmi pravděpodobně",
      very_unlikely: "Velmi nepravděpodobné",
      help_us_improve: "Jak pro vás můžeme zlepšit clockin?",
      what_do_you_agree_with: "S kterými tvrzeními souhlasíte?",
      choose_three_statements: "Vyberte až tři výroky.",
      hard_to_use: "Obtížná obsluha",
      lacking_features: "Příliš málo funkcí",
      does_not_help_me: "mi neulehčuje pracovní den",
      confusing: "matoucí",
      poorly_implemented: "Špatně implementované funkce",
      too_buggy: "přílišná náchylnost k chybám",
      too_slow: "dlouhá doba načítání",
      what_else: "Chcete nám ještě něco říct?",
      can_we_ask_you_a_few_questions: "Můžeme vám položit ještě několik otázek?",
      how_happy_are_you_with_the_introduction_of_clockin: "Jak jste spokojeni se zavedením clockin ve vaší společnosti?",
      how_much_do_you_enjoy_using_clockin: "Jak se vám používá clockin?",
      how_much_easier_does_clockin_make_your_work: "Jak moc vám odemykání a přivolávání usnadňuje každodenní práci?",
      how_happy_are_you_with_the_following_aspects: "Jak jste spokojeni s následujícími body?",
      clarity_of_the_app: "Přehlednost aplikace",
      simplicity_of_use: "Jednoduchost ovládání",
      app_features: "Funkce v aplikaci",
      feedback_received: "Vaše zpětná vazba byla přijata. Děkujeme, že jste si udělali čas.",
      thanks_for_taking_the_time: "Děkujeme, že jste si udělali čas.",
      what_can_we_do_to_improve: "Můžete nám říci více o svých zkušenostech, abychom příště mohli být ještě lepší?",
      what_can_we_do_to_get_it_right: "Můžete nám říct více o svých zkušenostech, abychom to příště mohli udělat správně?",
      comment_placeholder: "Vaše zpráva"
    }
  },
  travel_logs: {
    add: "Přidání podrobností o cestě",
    edit: "Upravit podrobnosti o cestě",
    saving: "Podrobnosti o cestě jsou uloženy...",
    saved_successfully: "Údaje o cestě byly úspěšně uloženy!",
    unable_to_save: "Bohužel to nevyšlo 😢"
  },
  attach_file: "Připojte soubor",
  image_to_text: {
    info: "Dbejte na to, aby byl text jasně rozpoznatelný a aby byl na obrázku vidět celý.",
    attach_image: "Přiložte obrázek",
    processing: "Váš text bude přečten v.",
    processing_failed: "Import bohužel nefungoval 😢",
    no_text_found: "Nebyl rozpoznán žádný text."
  },
  correction_enter_reason: "Uveďte prosím důvod opravy.",
  daily_notes: {
    add: "Napište poznámku",
    edit: "Upravit poznámku",
    saving: "Poznámka je uložena...",
    saved_successfully: "Poznámka byla úspěšně uložena!",
    unable_to_save: "Bohužel to nevyšlo 😢",
    no_notes_yet: "Nebyla vytvořena žádná poznámka",
    create_note: "Vytvořit"
  },
  calendar_sync: {
    title: "Synchronizovat plán",
    description: "Synchronizujte svůj pracovní rozvrh s kalendářem a mějte přehled o starých a nových schůzkách.",
    url: "Adresa ve formátu iCal",
    url_description: "Tuto adresu můžete použít pro přístup k tomuto kalendáři z jiných aplikací.",
    note: "Nápověda",
    note_description: "U některých kalendářů může trvat až 24 hodin, než se v nich zobrazí nové schůzky.",
    sync_now: "Synchronizace kalendáře",
    copied: "Zkopírovaná url adresa kalendáře."
  },
  registration: {
    skip_all: "Přeskočit vše",
    already_signed_up: "Už mám účet",
    title_1: "Začněme! Které časy byste chtěli zaznamenat pomocí clockin?",
    description_1: "Přizpůsobíme vám aplikaci clockin na míru",
    option_1_a: "Celková pracovní doba (příchod, odchod a přestávka)",
    option_1_b: "Pracovní doba projektu",
    title_2: "Chcete dokumentovat?",
    description_2: "Jaké požadavky musí být splněny?",
    option_2_a: "Fotografie",
    option_2_b: "Náčrtky",
    option_2_c: "Funkce poznámky",
    option_2_d: "Kontrolní seznamy a formuláře",
    option_2_e: "Digitální projektové soubory",
    title_3: "Co dalšího byste chtěli digitalizovat?",
    description_3: "Na webu clockin je toho k objevování mnohem víc, možná je tu něco pro vás.",
    option_3_a: "Dovolená",
    option_3_b: "Nemoci a absence",
    option_3_c: "Digitální osobní spis",
    option_3_d: "Analýza společnosti",
    option_3_e: "Plánování nasazení",
    option_3_f: "Daňový poradce pro přenos dat (DATEV)",
    title_4: "V jakém odvětví vaše společnost působí?",
    description_4: "Chceme vás lépe poznat, abychom mohli přizpůsobit hodiny více vašim potřebám.",
    option_4_a: "služby",
    option_4_b: "Řemesla",
    option_4_c: "Zdraví a wellness",
    option_4_d: "Nákup, objednávání a obchodování",
    option_4_e: "Hotel a stravování",
    option_4_f: "Automobily, doprava a stroje",
    option_4_g: "Ostatní průmyslová odvětví",
    title_5: "Kolik zaměstnanců je součástí vaší společnosti?",
    description_5: "S ohledem na počet zaměstnanců můžeme přizpůsobit clockin velikosti vaší společnosti.",
    title_6: "Super! Váš clockin je nyní nastaven",
    description_6: "Potřebujeme jen vaše jméno.",
    input_6_a: "Společnost",
    input_6_b: "Křestní jméno",
    input_6_c: "Příjmení",
    input_6_d: "Telefonní číslo",
    title_7: "Jste připraveni vyrazit! Vyzkoušejte clockin 14 dní zdarma!",
    input_7_a: "Vaše e-mailová adresa",
    description_7: "Na jakou e-mailovou adresu máme zaslat heslo?",
    input_7_b: "Tak jsem si uvědomil.",
    how_did_you_hear_about_clockin: "Jak jste se poprvé dozvěděl o společnosti clockin?",
    recommendation_option_1: "Doporučení",
    recommendation_option_2: 'Facebook',
    recommendation_option_3: 'Instagram',
    recommendation_option_4: "Vyhledávání na internetu",
    recommendation_option_5: 'LinkedIn',
    recommendation_option_6: "Srovnávací platforma",
    recommendation_option_7: "Články v časopisech a online",
    known_from: "Známé z",
    agb_1: "Odesláním formuláře přijímáte ",
    agb_2: 'AGB',
    agb_3: " a ",
    agb_4: "Zásady ochrany osobních údajů",
    start: "Zahájení testu",
    validation_failed: "Vyplňte prosím správně všechna pole."
  },
  clocki: {
    listening_heading: "Naslouchám vám",
    listening_subtext: "Jak ti mohu pomoci?",
    hi_0: "Dobrý den, jak vám mohu pomoci?",
    hi_1: "Jak vám mohu pomoci?",
    hi_2: "Dobrý den, jak vám mohu pomoci?",
    hi_3: "Moin moin, co pro vás mohu udělat?",
    hi_4: "Dobrý den, co pro vás mohu udělat?",
    hi_5: "Dobrý den, jak vám mohu pomoci?",
    // hi_1: 'Hi {name}​, sag mir, wie kann ich dir helfen?',
    // hi_2: 'Hi {name}​, wie kann ich dir helfen?',
    // hi_3: 'Hi {name}​, was kann ich für dich tun?',
    // hi_4: 'Moin {name}​, was kann ich für dich tun?',
    // hi_5: 'Hallo {name}​, wie kann ich dir helfen?',
    // hi_6: 'Grüß dich {name}​, wobei kann ich dich unterstützen?',
    // hi_7: 'Guten Tag {name}​, womit kann ich dir heute helfen?',
    speech_recognition_unavailable: "Bohužel se zdá, že rozpoznávání hlasu ve vašem zařízení nefunguje.",
    microphone_permission_denied: "Bohužel nemám přístup k vašemu mikrofonu. Zkontrolujte prosím oprávnění v nastavení, abych vás mohl slyšet.",
    please_speak: "Nyní můžete mluvit se společností Clocki",
    create_activity: "Vytvoření aktivity",
    modify_activity: "Aktivita změny",
    delete_activity: "Aktivita odstranění",
    create_daily_note: "Vytvoření denní poznámky",
    search_project: "Vyhledat projekt",
    note_copied: "Poznámka zkopírována",
    create_absence_request: "Požádat o absenci",
    delete_absence: "Odstranit nepřítomnost",
    confirm_deletion: "Jste si jisti, že vaše {activity_label} Lisování z {date} hodiny by měly být smazány?",
    confirm_absence_deletion: "Jste si jisti, že váš požadavek na {category} z {startDate} do {endDate} Chcete smazat?",
    task_before_modification: "Před: {task}",
    starts_at_before_modification: "Čas zahájení před: {startsAt}",
    ends_at_before_modification: "Čas ukončení před: {endsAt}",
    something_went_wrong: "Něco se pokazilo, zkuste to prosím později.",
    was_this_helpful: "Může vám Clocki pomoci?",
    actions: {
      CREATE_ABSENCE: {
        title: "Potvrzení nepřítomnosti"
      },
      CREATE_DAILY_NOTE: {
        title: "Vytvořit poznámku",
        daily_notes_disabled: "Funkce poznámky je bohužel deaktivována. Požádejte prosím správce, aby tuto funkci v kancelářském centru aktivoval.",
        success: "Poznámka úspěšně uložena do denního záznamu 🎉"
      },
      CREATE_PROJECT_NOTE: {
        title: "Vytvořit dokumentaci nyní",
        created_by_clocki: "Vytvořeno pomocí aplikace Clocki"
      },
      REDIRECT_TO_CORRECT_TIMES: {
        title: "Otevřete nyní \"Moje časy\""
      },
      REDIRECT_TO_MY_AREA: {
        title: "Otevřete nyní \"Moje oblast\""
      },
      REDIRECT_TO_CHANGE_PASSWORD: {
        title: "Otevřete \"Změnit heslo\""
      },
      CHANGE_ACTIVITY: {
        WORKING_TIME: "Razítko \"pracovní doba\" nyní",
        PAUSE: "Razítko \"Pause\" nyní",
        DRIVING_TIME: "Razítko \"čas na cestu\" nyní",
        LOGOUT: "Odemknout nyní"
      }
    }
  },
  review_prompt: {
    do_you_like_clockin: "Líbí se vám používat Clockin?"
  },
  translation_failed: "Překlad se bohužel nepovedl 😕",
  video_transcript_not_available: "Přepis není k dispozici",
  video_upload_succeeded: "Nahrávání videa dokončeno.",
  video_upload_failed: "Nahrávání videa selhalo.",
  video_send_failed: "Video momentálně nebylo možné odvysílat. Zkusíme to později znovu.",
  uploading_video: "Nahrávám video...",
  language_selection_header: "Vybraný jazyk",
  language_selection_message: "Vyberte si preferovaný jazyk",
  shifts: {
    my_shifts: "Moje směny",
    free_shifts: "Volné směny",
    next_shift: "Tvoje další směna",
    shift_not_found: "Žádné vrstvy nebyly nalezeny",
    show_shift_plan: "Prohledejte si tento rozvrh směn",
    no_shift_place: "Není uvedeno místo",
    no_shifts_assigned: "Momentálně nejsi přiřazen k žádné směně",
    free_shifts_unavailable: "Volné směny momentálně nejsou k dispozici",
    filter_shift_plans: "Filtrační směnné plány",
    no_shift_plans_available: "Nejsou k dispozici žádné rozvrhy směn",
    filter_locations: "Filtrační místa",
    no_locations_available: "Žádná místa nejsou k dispozici",
    no_plan_selected: "Nebyl vybrán žádný rozvrh směn",
    no_shifts_for_plan: "Pro tento plán se nenašly žádné vrstvy",
    no_shifts_for_location: "Nebyly nalezeny žádné směny pro vybrané místo",
    unknown_shift_plan: "Neznámý rozvrh směny",
    unknown_location: "Neznámé místo",
    loading_more_shifts: "Načti více vrstev..."
  },
  clockin_reminder_title: "Už v práci? 🔔",
  clockin_reminder: "Nezapomeňte se přihlásit.",
  clockout_reminder_title: "Už jste na konci dne? 🔔",
  clockout_reminder: "Nezapomeňte se odhlásit.",
  choose_clockin_reminder_time: "Čas připomínky přihlášení",
  choose_clockout_reminder_time: "Připomenutí odchodu",
  choose_break_reminder_time: "Délka pauzy",
  saved_successfully: "Úspěšně zachráněno 👍",
  clock_reminder_channel_name: "Připomínky známek",
  clock_reminder_channel_description: "Připomínky k přihlášení a odhlášení",
  break_reminder_title: "Stále si dáváš pauzu? ⏰",
  break_reminder: "Poznámka: Vaše přestávka stále běží.",
  // Video component translations
  video_not_supported: "Vaše zařízení video nepodporuje :/",
  video_loading_error: "Chyba při načítání videa",
  video_retry: "Nabít"
};